// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__22f5M","dragIcon":"SortableItem_dragIcon__3vEHj","disabled":"SortableItem_disabled__18RCt"};